import { Box } from "@mui/material";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Training from "./pages/Training";
import StrategicAllies from "./pages/StrategicAllies";
import Contact from "./pages/Contact";
import Register from "./pages/Register";
import VerifyAccount from "./pages/VerifyAccount";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Profile from "./pages/Profile";
import MemberQR from "./pages/MemberQR";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Navbar from "./components/Navbar";
import WhatsAppIcon from "./components/WhatsAppIcon";
import Scroll from "./components/Scroll";
import Footer from "./components/Footer";
import AboutUs from "./pages/AboutUs";
import Store from "./pages/Store";
import StoreProductDetail from "./pages/StoreProductDetail";
import StoreCheckout from "./pages/StoreCheckout";
import CartDrawer from "./components/CartDrawer";
import ChangeFirstPassword from "./components/Admin/ChangeFirstPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";

function AppContent() {
  const location = useLocation();
  const isAdminDashboard = location.pathname.startsWith("/admin/dashboard");
  const isAdminArea = location.pathname.startsWith("/admin");

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        bgcolor: isAdminDashboard ? "#0b1220" : "transparent",
      }}
    >
      {!isAdminArea && <Navbar />}
      {!isAdminArea && <CartDrawer />}

      <Box
        component="main"
        sx={{
          pt: isAdminArea ? 0 : { xs: "86px", md: "100px" },
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: isAdminDashboard ? "100vh" : "auto",
        }}
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/acerca-de-nosotros" element={<AboutUs />} />
          <Route path="/entrenamiento" element={<Training />} />
          <Route path="/nuestros-aliados" element={<StrategicAllies />} />
          <Route path="/contacto" element={<Contact />} />
          <Route path="/registro" element={<Register />} />
          <Route path="/verificar-cuenta" element={<VerifyAccount />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/mi-perfil" element={<Profile />} />
          <Route path="/member/:qr_token" element={<MemberQR />} />
          <Route path="/tienda" element={<Store />} />
          <Route path="/tienda/producto/:slug" element={<StoreProductDetail />} />
          <Route path="/checkout" element={<StoreCheckout />} />
          <Route path="/politicas-de-privacidad" element={<PrivacyPolicy />} />
          <Route path="/terminos-y-condiciones" element={<TermsAndConditions />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/admin/change-password" element={<ChangeFirstPassword />} />
          <Route
            path="/admin/dashboard"
            element={<Navigate to="/admin/dashboard/members" replace />}
          />
          <Route
            path="/admin/dashboard/:section"
            element={<AdminDashboard />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>

      {!isAdminArea && <Footer />}
      {!isAdminArea && <WhatsAppIcon />}
      {!isAdminArea && <Scroll />}
    </Box>
  );
}

function App() {
  return <AppContent />;
}

export default App;